import { formatCellphoneMasked, formatPhoneMasked, parseE164ToBrDigits } from '@solfacil/frontend-utils'

/** Telefone BR para exibição (E.164 ou dígitos nacionais). */
export function formatBrPhoneDisplay(phone: string | undefined | null): string {
  const d = parseE164ToBrDigits(phone ?? '')
  if (d.length === 11)
    return formatCellphoneMasked(d)
  if (d.length === 10)
    return formatPhoneMasked(d)
  return ''
}

/**
 * Normalizes a international date YYYY-MM-DD to DD/MM/YYYY
 * @param date A date in the format YYYY-MM-DD
 * @returns A date in the format DD/MM/YYYY
 * @example
 * normalizeDate('2021-12-31') // 31/12/2021
 * normalizeDate('2021-01-01') // 01/01/2021
 * normalizeDate('2021-01-01T00:00:00.000Z') // 01/01/2021
 */
export function convertToBrDate(date: string | undefined | null) {
  if (!date) {
    return ''
  }

  // check if date already is in the format DD/MM/YYYY
  if (/\d{2}\/\d{2}\/\d{4}/.test(date)) {
    return date
  }

  return date.split('T')[0].split('-').reverse().join('/')
}

/**
 * Converts a Brazilian date DD/MM/YYYY to an international date YYYY-MM-DD
 * @param date A date in the format DD/MM/YYYY
 * @returns A date in the format YYYY-MM-DD
 * @example
 * convertToISODate('31/12/2021') // 2021-12-31
 * convertToISODate('01/01/2021') // 2021-01-01
 */
export function convertToISODate(date: string | undefined | null) {
  if (!date) {
    return ''
  }

  // check if date already is in the format YYYY-MM-DD
  if (/\d{4}-\d{2}-\d{2}/.test(date)) {
    return date
  }

  const [day, month, year] = date.split('/')
  return `${year}-${month}-${day}`
}

/**
 * Converts a Brazilian date format DD/MM/YYYY to international date format YYYY-MM-DD
 * @param date A date in the format DD/MM/YYYY
 * @returns A date in the format YYYY-MM-DD
 * @example
 * convertToIntlDate('31/12/2021') // 2021-12-31
 * convertToIntlDate('01/01/2021') // 2021-01-01
 */
export function convertToIntlDate(date: string | undefined | null): string {
  if (!date) {
    return ''
  }

  const parts = date.split('/')
  if (parts.length !== 3) {
    return ''
  }

  const [day, month, year] = parts
  return `${year}-${month}-${day}`
}
